import { connect } from 'react-redux'
import { authActions } from 'store/user'
import { drawerActions } from 'store/drawer'
import NavBar from './NavBar'

const mapDispatchToProps = {
  onLogout: authActions.logout,
  ...drawerActions
}

const mapStateToProps = ({
  user,
  userReducer,
  subroute,
  location,
  modal,
  navBar,
  strings,
  instruments,
  consent,
  caregiver
}) => {
  const selectedUser = userReducer ? userReducer.user.nickname : undefined

  const unreadAnnouncementInstances = instruments?.instancesList?.filter(
    instance =>
      instance?.instrument_type === 'ANNOUNCEMENT' &&
      !instance?.instances?.[0]?.read
  )

  const pendingConsents = consent?.v2Consents.length

  return {
    selectedUser,
    user,
    location,
    modal,
    subroute,
    strings,
    unreadCount: unreadAnnouncementInstances?.length,
    showNavLinks:
      subroute !== 'studies' && subroute !== 'users' && subroute !== 'audit',
    navProps: navBar,
    humiIsabellaDisabled:
      user?.study?.config?.is_rewardless_study &&
      user?.study?.config?.is_avatarless_study,
    pendingConsents,
    caregiver
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar)
